import { IconButton } from '@mui/material';
import React, { PropsWithChildren } from 'react';
import { Edit } from 'react-feather';
import { DeleteButton } from '../delete-button/DeleteButton';

interface DefaultActionsProps {
  className?: string;
  id?: string;
  loading?: boolean;
  deleteTitle?: string;
  link?: string;
  deleteMessage?: string;
  onDelete?: () => void;
  onEdit?: () => void;
}

export function DefaultActions({
  className,
  deleteTitle,
  link,
  loading,
  deleteMessage,
  id,
  children,
  onDelete,
  onEdit,
}: PropsWithChildren<DefaultActionsProps>): JSX.Element {
  return (
    <div className={className}>
      {children}
      {onEdit || link ? (
        <IconButton
          color="primary"
          data-test-id={id && `edit-button-${id}`}
          aria-label="Edit"
          href={link}
          target="_blank"
          onClick={onEdit}
          size="large"
        >
          <Edit size={20} />
        </IconButton>
      ) : null}
      {onDelete ? (
        <DeleteButton
          title={deleteTitle}
          message={deleteMessage}
          id={id}
          loading={loading}
          onDelete={onDelete}
        />
      ) : null}
    </div>
  );
}
